function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("linearGradient", {
  id: "icon-linkedin-square-gradient_svg__a",
  gradientUnits: "userSpaceOnUse",
  x1: 20,
  x2: 20,
  y2: 40
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#c31446"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#891731"
}));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M32 0H8a8 8 0 00-8 8v24a8 8 0 008 8h24a8 8 0 008-8V8a8 8 0 00-8-8zM13.63 31.72H8.4V14.89h5.23zM11 12.59a3 3 0 113-3 3 3 0 01-3 3zm22.2 19.13H28v-8.19c0-2 0-4.46-2.72-4.46s-3.13 2.13-3.13 4.32v8.33h-5.24V14.89h5v2.3H22a5.48 5.48 0 014.94-2.72c5.3 0 6.28 3.49 6.28 8z",
  fill: "url(#icon-linkedin-square-gradient_svg__a)"
});

function SvgIconLinkedinSquareGradient(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNDAgNDAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPjxsaW5lYXJHcmFkaWVudCBpZD0iaWNvbi1saW5rZWRpbi1hIiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSIgeDE9IjIwIiB4Mj0iMjAiIHkyPSI0MCI+PHN0b3Agb2Zmc2V0PSIwIiBzdG9wLWNvbG9yPSIjYzMxNDQ2Ii8+PHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjODkxNzMxIi8+PC9saW5lYXJHcmFkaWVudD48cGF0aCBkPSJtMzIgMGgtMjRhOCA4IDAgMCAwIC04IDh2MjRhOCA4IDAgMCAwIDggOGgyNGE4IDggMCAwIDAgOC04di0yNGE4IDggMCAwIDAgLTgtOHptLTE4LjM3IDMxLjcyaC01LjIzdi0xNi44M2g1LjIzem0tMi42My0xOS4xM2EzIDMgMCAxIDEgMy0zIDMgMyAwIDAgMSAtMyAzem0yMi4yIDE5LjEzaC01LjJ2LTguMTljMC0yIDAtNC40Ni0yLjcyLTQuNDZzLTMuMTMgMi4xMy0zLjEzIDQuMzJ2OC4zM2gtNS4yNHYtMTYuODNoNXYyLjNoLjA5YTUuNDggNS40OCAwIDAgMSA0Ljk0LTIuNzJjNS4zIDAgNi4yOCAzLjQ5IDYuMjggOHoiIGZpbGw9InVybCgjaWNvbi1saW5rZWRpbi1hKSIvPjwvc3ZnPgo=";
export { SvgIconLinkedinSquareGradient as ReactComponent };